module.exports = __webpack_public_path__ + "static/north-building-mobile.a3a3df28.webp";